import DivertedFlightInfo from "./DivertedFlightInfo";

export default DivertedFlightInfo;
